import { Stack, Theme, useTheme } from "@mui/material";
import {
  BankIcon,
  CreditCardIcon,
  PaitentIcon,
  PaymentIcon,
  UserIcon,
  WalletIcon,
  PatientListIcon
} from "../../../ui/icons";

const WalletTypeIcon = ({
  type,
  bgcolor,
  size = 40,
}: {
  type: "basic" | "credit" | "loan" | "debit" | "other" | "cash" | "vietcombank" | "techcombank" | "person";
  bgcolor: string;
  size?: number;
}) => {
  const theme: Theme = useTheme();
  const renderIcon = () => {
    switch (type) {
      case "basic":
        return <PaymentIcon fontSize={24} />;
      case "credit":
        return <CreditCardIcon fontSize={24} />;
      case "loan":
        return <PatientListIcon fontSize={24} />;
      case "debit":
        return <PaitentIcon fontSize={24} />;
      case "other":
        return <WalletIcon fontSize={24} />;
      case "cash":
        return <PaymentIcon fontSize={24} />;
      case "vietcombank":
      case "techcombank":
        return <BankIcon fontSize={24} />;
      case "person":
        return <UserIcon fontSize={24} />;
      default:
        return <PaymentIcon fontSize={24} />;
    }
  };

  return (
    <Stack
      width={size ?? 40}
      height={size ?? 40}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      bgcolor={bgcolor ?? theme.palette.purple[500]}
      color={theme.palette.common.white}
      sx={{ aspectRatio: 1 }}
    >
      {renderIcon()}
    </Stack>
  );
};

export default WalletTypeIcon;
